/* Developed by: Philip C. Diaz
   Experience: Javascript Developer | Senior Frontend Developer | ReactJS Developer
   Email: diazphi@gmail.com
   License: Forever Free, you are freely to improve and modify.
*/      
"use strict";
window.theme = window.theme || {}
theme.collectionSearchEngine = function() {

    function collectionSearchEngine() {

        this.selector = {
            search: document.querySelector('.breadcrumb_pr_wrap input.quick-search-input'),
            result: document.querySelector('.breadcrumb_pr_wrap .collection-quick-search-list-result > ul'),
            alphabet: document.querySelectorAll('.breadcrumb_pr_wrap .collection-quick-search-sort-by > ul > li'),
            filter_title: document.querySelector('.breadcrumb_pr_wrap .collection-quick-search-keyword > h3'),
            az: document.querySelectorAll('.breadcrumb_pr_wrap .collection-quick-search-sort-by > ul > li > button'),
            breadhistory: document.querySelector('.breadcrumb_pr_wrap .sp-breadcrumb a.dib:last-of-type'),
            expandable: document.querySelector('.breadcrumb_pr_wrap button.expand-down'),
            category: document.querySelectorAll('.breed-category .js-breed-category-link'),
            breedhomepagelink: document.querySelectorAll('.breed-homepage-link'),
            different_color: document.querySelectorAll('.collection-different-color-container > ul > li > a')   
        }
        this.container = {
            collections: document.querySelector('.breadcrumb_pr_wrap .js-collection-data-list'),
            search_result: document.querySelector('.breadcrumb_pr_wrap .collection-quick-search-list-result'),
            search_close: document.querySelector('.breadcrumb_pr_wrap .search-close'),
            container: document.querySelector('.breadcrumb_pr_wrap .collection-quick-search'),
            sortby: document.querySelector('.breadcrumb_pr_wrap .collection-quick-search-sort-by > ul')
        }
        this.databank = [];

        this.load();

    }

    collectionSearchEngine.prototype.load = function() {
        var _ = this; 
        let array_collections_title = JSON.parse(_.container.collections.getAttribute('data-array-collections-title'));
        let array_collections_url = JSON.parse(_.container.collections.getAttribute('data-array-collections-url'));
        let array_collections_count = JSON.parse(_.container.collections.getAttribute('data-array-collections-count'));
        var JSONItems = '{"collections":[{"title":"'+array_collections_title[0]+'","url":"'+array_collections_url[0]+'","count":"'+array_collections_count[0]+'"}]}';
        _.databank = JSON.parse(JSONItems);
                if(array_collections_title.length>1) {
                    array_collections_title.forEach((element,index) => {
                        if(index>0) {
                            _.databank['collections'].push({"title":`${array_collections_title[index]}`,"url":`${array_collections_url[index]}`,"count":`${array_collections_count[index]}`});
                        }                                        
                    });                                   
                }    
        _.selector.search.addEventListener('keyup', (event) => {
            _.search();
            if (event.key === "Escape") {
                _.closeresult();
            }
        });
        _.selector.alphabet.forEach(element => {
            element.addEventListener('click', (event) => {
               [].forEach.call(_.selector.az, (btn) => {
                    btn.classList.remove('active');
                })
               if( event.target.closest('button'))event.target.closest('button').classList.add('active');
                _.sortby(event);
            });
        })
        _.container.search_close.addEventListener('click', () => {
           _.closeresult();
       })
       if(_.selector.breadhistory) {
           if(_.getcookies('breedhistorytitle') !== 'empty') {
            _.selector.breadhistory.textContent = _.getcookies('breedhistorytitle');
            _.selector.breadhistory.href = _.getcookies('breedhistoryurl');                 
            _.selector.filter_title.innerHTML = 'Showing Breed: <strong>'+_.getcookies('breedhistorytitle')+'</strong>';
           if(_.selector.category.length>0) {
            _.selector.category.forEach(e => {
                        e.href = _.getcookies('breedhistoryurl')+'?filter.p.m.productcategory.level1='+e.getAttribute('data-category-handle'); 
                        e.addEventListener('click', (event) => {
                            _.setfirstcookies('empty');                      
                        })                          
            })
            }
           } else {
           _.selector.breadhistory.textContent = 'No Breed Selected';
           _.selector.filter_title.innerHTML = 'Showing Breed: <strong>No Breed Selected</strong>';
           if(_.selector.category.length>0) {
           _.selector.category.forEach(e => {
                    e.addEventListener('click', (event) => {                       
                            _.setfirstcookies(event.target.closest('a').getAttribute('data-category-handle'));
                      
                    })                    
               })
            }   
           }
       }
       _.selector.expandable.addEventListener('click', (event) => {
           if(_.container.sortby.classList.contains('active')) {
              _.container.sortby.classList.remove('active');
              if(event.target.closest('button'))event.target.closest('button').classList.remove('expanded');1
           } else {
              _.container.sortby.classList.add('active');
              if(event.target.closest('button'))event.target.closest('button').classList.add('expanded');
           }           
       })
       let listbreed = document.querySelectorAll('.collection-quick-search-list-result > ul > li > button');
       listbreed.forEach(element => {
           element.addEventListener('click', (event) => {
               _.setcookies(event.target.closest('button').textContent,event.target.closest('button').getAttribute('data-url'));
           });
       })   
       if(_.selector.breedhomepagelink.length>0) {
           _.selector.breedhomepagelink.forEach(el => {
                    el.addEventListener('click', event => {
                        _.setcookies(event.target.getAttribute('data-category-handle'),event.target.href);
                    })
           })
       }    
       if(_.selector.different_color.length>0) {
            _.selector.different_color.forEach(element => {
            element.addEventListener('click', (event) => {
                _.setcookies(event.target.closest('a').getAttribute('data-collection-title'),event.target.closest('a').getAttribute('data-collection-url'));
            });
        })
        } 
    }
    
    collectionSearchEngine.prototype.search = function() {
            var _ = this;
            let result_container = _.selector.result;
            let count_items = 0;
            if(_.databank['collections'].length>0) {
               result_container.innerHTML = '';
               _.container.search_result.classList.add('active');
               _.container.search_close.classList.add('active');
                _.databank['collections'].forEach(value => {
                    var title = value.title.toLowerCase();
                    var keyword = _.selector.search.value.toLowerCase();
                    if(title.includes(keyword)) {
                        var result_list = document.createElement('li');
                        var result_link = document.createElement('button');
                        result_link.setAttribute('type','button');
                        result_link.setAttribute('data-url',value.url);
                        result_link.textContent = value.title;
                        result_list.append(result_link);
                        result_container.append(result_list);
                        count_items++;
                    }                   
                })
                let listbreed = document.querySelectorAll('.collection-quick-search-list-result > ul > li > button');
                listbreed.forEach(element => {
                    element.addEventListener('click', (event) => {
                        _.setcookies(event.target.closest('button').textContent,event.target.closest('button').getAttribute('data-url'));
                    });
                })
                if(count_items>0 && count_items<=20) {
                    _.selector.result.classList.add('gr-one-fifth');
                    _.selector.result.classList.remove('gr-full');
                    _.selector.result.classList.remove('gr-one-fourth');
                    _.selector.result.classList.remove('gr-one-third');
                    _.selector.result.classList.remove('gr-one-half');
                }
                if(count_items>=20 && count_items<=50) {
                    _.selector.result.classList.add('gr-one-fourth');
                    _.selector.result.classList.remove('gr-full');
                    _.selector.result.classList.remove('gr-one-fifth');
                    _.selector.result.classList.remove('gr-one-third');
                    _.selector.result.classList.remove('gr-one-half');
                }
                if(count_items>=51 && count_items<=100) {
                    _.selector.result.classList.add('gr-one-third');
                    _.selector.result.classList.remove('gr-full');
                    _.selector.result.classList.remove('gr-one-fifth');
                    _.selector.result.classList.remove('gr-one-fourth');
                    _.selector.result.classList.remove('gr-one-half');
                }
                if(count_items>=101 && count_items<=150) {
                    _.selector.result.classList.add('gr-one-half');
                    _.selector.result.classList.remove('gr-full');
                    _.selector.result.classList.remove('gr-one-fifth');
                    _.selector.result.classList.remove('gr-one-fourth');
                    _.selector.result.classList.remove('gr-one-third');
                }
                if(count_items>=151) {
                    _.selector.result.classList.add('gr-full');
                    _.selector.result.classList.remove('gr-one-fifth');
                    _.selector.result.classList.remove('gr-one-fourth');
                    _.selector.result.classList.remove('gr-one-third');
                    _.selector.result.classList.remove('gr-one-half');
                }
                if(count_items==0) {
                    _.selector.result.classList.remove('gr-one-fifth');
                    _.selector.result.classList.remove('gr-full');
                    _.selector.result.classList.remove('gr-one-fourth');
                    _.selector.result.classList.remove('gr-one-third');
                    _.selector.result.classList.remove('gr-one-half');
                }
            } else {
                result_container.innerHTML = '';
                _.container.search_result.classList.remove('active');
                _.container.search_close.classList.add('active');
                    _.selector.result.classList.remove('gr-full');
                    _.selector.result.classList.remove('gr-one-fifth');
                    _.selector.result.classList.remove('gr-one-fourth');
                    _.selector.result.classList.remove('gr-one-third');
                    _.selector.result.classList.remove('gr-one-half');
            }
    }

    collectionSearchEngine.prototype.sortby = function(event) {
        var _ = this;
        let result_container = _.selector.result;
        let count_items = 0;
        if(_.databank['collections'].length>0) {
           result_container.innerHTML = '';
           _.container.search_result.classList.add('active');
           _.container.search_close.classList.add('active');
            _.databank['collections'].forEach(value => {
                var title = value.title.toLowerCase();
                var keyword = event.target.closest('button').textContent.toLowerCase();
                if(title.startsWith(keyword)) {
                    var result_list = document.createElement('li');
                    var result_link = document.createElement('button');
                    result_link.setAttribute('type','button');
                    result_link.setAttribute('data-url',value.url);
                    result_link.textContent = value.title;
                    result_list.append(result_link);
                    result_container.append(result_list);
                    count_items++;
                } else if (keyword === 'all:') {
                    var result_list = document.createElement('li');
                    var result_link = document.createElement('button');
                    result_link.setAttribute('type','button');
                    result_link.setAttribute('data-url',value.url);
                    result_link.textContent = value.title;
                    result_list.append(result_link);
                    result_container.append(result_list);
                    count_items++;
                }                  
            })
            let listbreed = document.querySelectorAll('.collection-quick-search-list-result > ul > li > button');
            listbreed.forEach(element => {
                element.addEventListener('click', (event) => {
                    _.setcookies(event.target.closest('button').textContent,event.target.closest('button').getAttribute('data-url'));
                });
            })            
            if(count_items>0 && count_items<=20) {
                _.selector.result.classList.add('gr-one-fifth');
                _.selector.result.classList.remove('gr-full');
                _.selector.result.classList.remove('gr-one-fourth');
                _.selector.result.classList.remove('gr-one-third');
                _.selector.result.classList.remove('gr-one-half');
            }
            if(count_items>=20 && count_items<=50) {
                _.selector.result.classList.add('gr-one-fourth');
                _.selector.result.classList.remove('gr-full');
                _.selector.result.classList.remove('gr-one-fifth');
                _.selector.result.classList.remove('gr-one-third');
                _.selector.result.classList.remove('gr-one-half');
            }
            if(count_items>=51 && count_items<=100) {
                _.selector.result.classList.add('gr-one-third');
                _.selector.result.classList.remove('gr-full');
                _.selector.result.classList.remove('gr-one-fifth');
                _.selector.result.classList.remove('gr-one-fourth');
                _.selector.result.classList.remove('gr-one-half');
            }
            if(count_items>=101 && count_items<=150) {
                _.selector.result.classList.add('gr-one-half');
                _.selector.result.classList.remove('gr-full');
                _.selector.result.classList.remove('gr-one-fifth');
                _.selector.result.classList.remove('gr-one-fourth');
                _.selector.result.classList.remove('gr-one-third');
            }
            if(count_items>=151) {
                _.selector.result.classList.add('gr-full');
                _.selector.result.classList.remove('gr-one-fifth');
                _.selector.result.classList.remove('gr-one-fourth');
                _.selector.result.classList.remove('gr-one-third');
                _.selector.result.classList.remove('gr-one-half');
            }
            if(count_items==0) {
                _.selector.result.classList.remove('gr-one-fifth');
                _.selector.result.classList.remove('gr-full');
                _.selector.result.classList.remove('gr-one-fourth');
                _.selector.result.classList.remove('gr-one-third');
                _.selector.result.classList.remove('gr-one-half');
            }
        } else {
            _.selector.result.innerHTML = '';
            _.container.search_result.classList.remove('active');
            _.container.search_close.classList.remove('active');
            _.selector.result.classList.remove('gr-full');
            _.selector.result.classList.remove('gr-one-fifth');
            _.selector.result.classList.remove('gr-one-fourth');
            _.selector.result.classList.remove('gr-one-third');
            _.selector.result.classList.remove('gr-one-half');
        }
    }
    collectionSearchEngine.prototype.closeresult = function() {
        var _ = this;
        _.selector.result.innerHTML = '';
        _.container.search_result.classList.remove('active');
        _.container.search_close.classList.remove('active');
    }
    collectionSearchEngine.prototype.setcookies = function(cvalue,clink) {
        var _ = this;
        const d = new Date();
        d.setTime(d.getTime()+(30*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = 'breedhistorytitle'+"="+cvalue+";"+expires+";path=/";
        document.cookie = 'breedhistoryurl'+"="+clink+";" +expires+";path=/";
        let firstcookiescat = _.getfirstcookies('breedcategoryhistorytitle');
        if(firstcookiescat !== 'empty') {
           _.setfirstcookies('empty');
           window.location.href = clink+'?filter.p.m.productcategory.level1='+firstcookiescat;          
        } else {
           _.setfirstcookies('empty');
           window.location.href = clink;                   
        }               
    }
    collectionSearchEngine.prototype.setfirstcookies = function(cvalue) {
        const d = new Date();
        d.setTime(d.getTime()+(30*24*60*60*1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = 'breedcategoryhistorytitle'+"="+cvalue+";"+expires+";path=/";
    }
    collectionSearchEngine.prototype.getfirstcookies = function(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "empty";
    }
    collectionSearchEngine.prototype.getcookies = function(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "empty";
    }

  theme.collectionSearchEngine = new collectionSearchEngine;

}

theme.collectionSearchEngine();